import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

export const search: ThemeUICSSObject = {
  '.search__input': {
    borderRadius: '20px',
  },
};
